<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert v-if="is_premium" dense text class="body-2 mb-5" type="info">
      Silakan melakukan verifikasi dengan menekan tombol <b>"Periksa"</b>. Fitur Presensi Swafoto digunakan operator untuk
      verifikasi data presensi pengguna yang berkendala presensi biometriknya. Sehingga mereka menggunakan fitur
      presensi swafoto di Apps. Fitur <b>Rekomendasi Deepface</b> bertujuan memudahkan proses verifikasi oleh operator.
      Sistem langsung mencocokkan otomatis antara data profil foto dengan foto presensi swafoto pengguna, dengan
      menampilkan persentase kecocokan keduanya
    </v-alert>
    <m-card-list
      titleLock="Presensi Swafoto"
      descLock="Presensi tidak ada jaringan internet sangat dimungkinkan bisa dilakukan, dengan menggunakan presensi swafoto (selfie) oleh anggota. Operator instansi dapat langsung mengecek kevalidan data selfie anggota tersebut"
      two-line
      title="Presensi Swafoto"
      label-cari="Cari Presensi Swafoto"
      search
      select
      filterUser
      filterStatus
      filterWaktu
      filterRadius
      @filter="filter"
      :items="items"
      :headers="headers"
      refresh
      @refresh="refresh"
      :page="page"
      footer
      @search="
            (search) => {
              textSearch = search
              process()
            }
          "
      @change:page="
            (pg) => {
              cp = pg
              process()
            }
          "
      @add="add"
    >
      <template v-slot:items="{ props, item }">
        <tr v-if="$vuetify.breakpoint.smAndUp">
          <td>
            {{ pVal(item, 'waktu_scan') | toD }}
            {{ $setTimezone(item.waktu_scan, 2) || '' }}
          </td>
          <td class="font-weight-bold">{{ pVal(item, 'nama') }}</td>
          <td>
                <span v-if="item.status_lokasi !== null">
                  {{
                    item.status_lokasi === 0
                      ? 'Luar Lokasi'
                      : item.status_lokasi === 1
                        ? 'Dalam Lokasi'
                        : 'Lokasi Tidak Tersedia'
                  }}
                </span>
          </td>
          <td>
            <template v-if="getDeepObj(item, 'deepface.similarity')">
              <v-progress-linear
                rounded
                :color="
                      Number(getDeepObj(item, 'deepface.similarity')) >= 70
                        ? 'success'
                        : Number(getDeepObj(item, 'deepface.similarity')) < 70 &&
                          Number(getDeepObj(item, 'deepface.similarity')) >= 50
                        ? 'orange'
                        : 'red'
                    "
                height="13"
                :value="Number(getDeepObj(item, 'deepface.similarity'))"
              >
                    <span class="white--text caption" style="margin-top: 1pt">
                      {{ getDeepObj(item, 'deepface.similarity') }}%
                    </span>
              </v-progress-linear>
            </template>
            <template v-else>
              <span class="orange--text">Belum ada rekomendasi</span>
            </template>
          </td>
          <td v-if="!is_disable">
            <v-chip
              class="text-lowercase"
              small
              outlined
              :color="$presensiManual.statusColor(item.m_status.k_status)"
            >{{ pVal(item.m_status, 'status') }}</v-chip
            >
          </td>
          <td>
            <v-chip
              @click="cekPresensi(item)"
              class="ma-2 elevation-custom"
              label
              color="primary"
              text-color="white"
            >
              <v-icon small class="mr-2">mdi-file-find</v-icon>Periksa
            </v-chip>
          </td>
        </tr>
        <tr v-else>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2"> Tanggal </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, 'waktu_scan') | toD }}
              {{ $setTimezone(item.waktu_scan, 2) }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2"> Nama </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, 'nama') }}
            </div>
          </td>
          <td class="v-data-table__mobile-row" v-if="!is_disable">
            <div class="v-data-table__mobile-row__header mr-2"> Radius Lokasi Presensi </div>
            <div class="v-data-table__mobile-row__cell">
              {{
                item.status_lokasi === 0
                  ? 'Luar Lokasi'
                  : item.status_lokasi === 1
                    ? 'Dalam Lokasi'
                    : 'Lokasi Tidak Tersedia'
              }}
            </div>
          </td>
          <td class="v-data-table__mobile-row" v-if="!is_disable">
            <div class="v-data-table__mobile-row__header mr-2"> Status </div>
            <div class="v-data-table__mobile-row__cell">
              <v-chip
                small
                class="text-capitalize"
                outlined
                :color="$presensiManual.statusColor(item.m_status.k_status)"
              >{{ pVal(item.m_status, 'status') }}</v-chip
              >
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2"> Aksi </div>
            <div class="v-data-table__mobile-row__cell">
              <v-chip
                @click="cekPresensi(item)"
                class="ma-0 elevation-custom"
                label
                small
                color="info"
                text-color="white"
              >
                <v-icon small>mdi-file-find</v-icon>Cek
              </v-chip>
            </div>
          </td>
        </tr>
      </template>
    </m-card-list>
    <PengesahanDlg ref="dlg" />
  </v-container>
</template>

<script>
import { isCan } from '@/tools'
import BlockCard from '@/components/BlockCard'
import PengesahanDlg from '../components/Pengesahan.vue'

export default {
  components: {
    BlockCard,
    PengesahanDlg,
  },
  data() {
    return {
      userid: 0,
      presensiManual: {
        tanggalAwal: null,
        tanggalAkhir: null,
      },
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [],
      stat: {
        jenis_kelamin: { data: [], legend: [] },
        usia: { data: [], legend: [] },
      },
      more_menu: [
        { divider: true },
        {
          title: 'Hapus',
          click: (i, o) => this.hapus(o),
          check: () => isCan('presensi-manual.approval'),
        },
      ],
    }
  },
  activated() {
    this.presensiManual.tanggalAwal = null
    this.presensiManual.tanggalAkhir = null
    this.userid = 0
    this.status_id = null
    this.process()
    if (this.is_disable) {
      this.headers = [
        { text: 'Tanggal', align: 'left', value: 'waktu_scan' },
        { text: 'Nama', align: 'left', value: 'user' },
        { text: 'Radius Lokasi Presensi', align: 'left', value: 'radius' },
        { text: '', align: 'left', sortable: false },
      ]
    } else {
      this.headers = [
        { text: 'Tanggal', align: 'left', value: 'waktu_scan' },
        { text: 'Nama', align: 'left', value: 'user' },
        { text: 'Radius Lokasi Presensi', align: 'left', value: 'radius' },
        { text: 'Rekomendasi AI Deepface', align: 'left', value: 'deepface', sortable: false },
        { text: 'Status', align: 'left', value: 'jenis' },
        { text: '', align: 'left', sortable: false },
      ]
    }
  },
  methods: {
    process() {
      this.$store
        .dispatch('presensiManual/get', {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
            from: this.presensiManual.tanggalAwal,
            to: this.presensiManual.tanggalAkhir,
            status_lokasi: this.presensiManual.radius,
            kegiatan_id: this.kegiatanid,
            k_status: this.status_id,
            user_id: this.userid,
          },
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    filter(data) {
      this.cp = 1
      this.userid = data.user
      this.status_id = data.status
      this.presensiManual.radius = data.radius

      if (data.dateRange) {
        this.presensiManual.tanggalAwal = data.from
        this.presensiManual.tanggalAkhir = data.to
        this.process()
      } else {
        this.presensiManual.tanggalAwal = null
        this.presensiManual.tanggalAkhir = null
        this.process()
      }
    },
    refresh() {
      this.process(this.range)
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.process(this.range)
      })
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.process(this.range)
      })
    },
    cekPresensi(item) {
      this.$refs.dlg.open(item).then(() => {
        this.process(this.range)
      })
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="ma-1 mb-4 pa-1 row red lighten-4 red--text text--darken-4">

            <i class="ma-3 v-icon v-alert__icon mdi mdi-information-outline red--text text--darken-4"></i>

          <div class="col m11 pa-1 pt-3">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.keterangan}<br>
        </div>

      `
      )
        .then(() => this.$store.dispatch('presensiManual/drop', item.absensi_id))
        .then(() => {
          this.$info('Data berhasil dihapus')
        })
        .then(() => this.load())
        .catch((e) => e)
    },

    ajukan(item) {
      const tanggal = this.$options.filters.toD(item.tanggal)
      this.$confirmDanger(
        `Apakah Anda yakin akan mengajukan data ini ?<br>
        <div class="mt-2 title grow text-center">
          IZIN ${item.keterangan} pada Hari ${tanggal}<br>
        </div>
      `
      )
        // .then(() => this.$store.dispatch("presensiManual/drop", item.hari_libur_id))
        .then(() => {
          this.$info('Data berhasil diajukan')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    setujui(item) {
      const tanggal = this.$options.filters.toD(item.tanggal)
      this.$confirmDanger(
        `Apakah Anda yakin akan menyetujui data ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama} ${item.jenis} : ${item.keterangan}<br>
          pada Hari ${tanggal}
        </div>
      `,
        {
          keterangan: 'keterangan',
        }
      )
        .then(() => {
          this.$info('Data berhasil disetujui')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    tolak(item) {
      const tanggal = this.$options.filters.toD(item.tanggal)
      this.$confirmDanger(
        `Apakah Anda yakin akan menolak data ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama} ${item.jenis} : ${item.keterangan}<br>
          pada Hari ${tanggal}
        </div>
      `,
        {
          keterangan: 'keterangan',
        }
      )
        // .then(() => this.$store.dispatch("presensiManual/drop", item.hari_libur_id))
        .then(() => {
          this.$info('Data berhasil ditolak')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
  },
}
</script>
<style scoped>
.elevation-custom {
  -webkit-box-shadow: 0px 0px 10px 3px #4362be56 !important;
}
</style>
